function k(a) {
  return "string" == typeof a ? new GraphQLError(a) : "object" == typeof a && a.message ? new GraphQLError(a.message, a.nodes, a.source, a.positions, a.path, a, a.extensions || {}) : a;
}

function l() {
  return this.message;
}

function n(a, b) {
  a |= 0;
  for (var c = 0, d = 0 | b.length; c < d; c++) {
    a = (a << 5) + a + b.charCodeAt(c);
  }
  return a;
}

function t(a) {
  var b, c, d, e, f, g;
  if (null === a || q.has(a)) {
    return "null";
  }
  if ("object" != typeof a) {
    return JSON.stringify(a) || "";
  }
  if (a.toJSON) {
    return t(a.toJSON());
  }
  if (Array.isArray(a)) {
    for (b = "[", c = 0, d = a.length; c < d; c++) {
      0 < c && (b += ",");
      b += 0 < (e = t(a[c])).length ? e : "null";
    }
    return b + "]";
  }
  if (!(b = Object.keys(a).sort()).length && a.constructor && a.constructor !== Object) {
    return b = r.get(a) || Math.random().toString(36).slice(2), r.set(a, b), '{"__key":"' + b + '"}';
  }
  q.add(a);
  c = "{";
  d = 0;
  for (e = b.length; d < e; d++) {
    (g = t(a[f = b[d]])) && (1 < c.length && (c += ","), c += t(f) + ":" + g);
  }
  q.delete(a);
  return c + "}";
}

function u(a) {
  q.clear();
  return t(a);
}

function v(a) {
  var b = ("string" != typeof a ? a.loc && a.loc.source.body || print(a) : a).replace(/([\s,]|#[^\n\r]+)+/g, " ").trim();
  "string" != typeof a && (a.loc ? (a = "definitions" in a && w(a)) && (b = "# " + a + "\n" + b) : a.loc = {
    start: 0,
    end: b.length,
    source: {
      body: b,
      name: "gql",
      locationOffset: {
        line: 1,
        column: 1
      }
    }
  });
  return b;
}

function y(a) {
  if ("string" == typeof a) {
    var b = n(5381, v(a)) >>> 0;
    a = x.get(b) || parse(a, {
      noLocation: !0
    });
  } else {
    b = a.__key || n(5381, v(a)) >>> 0, a = x.get(b) || a;
  }
  a.loc || v(a);
  a.__key = b;
  x.set(b, a);
  return a;
}

function w(a) {
  var b, c, d;
  for (b = 0, c = a.definitions.length; b < c; b++) {
    if ((d = a.definitions[b]).kind === Kind.OPERATION_DEFINITION && d.name) {
      return d.name.value;
    }
  }
}

function z(a, b, c) {
  return {
    operation: a,
    data: b.data,
    error: Array.isArray(b.errors) ? new m({
      graphQLErrors: b.errors,
      response: c
    }) : void 0,
    extensions: "object" == typeof b.extensions && b.extensions || void 0
  };
}

function A(a, b, c) {
  return {
    operation: a,
    data: void 0,
    error: new m({
      networkError: b,
      response: c
    }),
    extensions: void 0
  };
}

function B() {
  return (B = Object.assign || function(a) {
    var b, c, d;
    for (b = 1; b < arguments.length; b++) {
      c = arguments[b];
      for (d in c) {
        Object.prototype.hasOwnProperty.call(c, d) && (a[d] = c[d]);
      }
    }
    return a;
  }).apply(this, arguments);
}

function makeFetchBody(a) {
  return {
    query: print(a.query),
    operationName: w(a.query),
    variables: a.variables || void 0,
    extensions: void 0
  };
}

function makeFetchURL(a, b) {
  var c = a.context.url;
  if ("query" !== a.kind || !a.context.preferGetMethod || !b) {
    return c;
  }
  a = [];
  b.operationName && a.push("operationName=" + encodeURIComponent(b.operationName));
  b.query && a.push("query=" + encodeURIComponent(b.query.replace(/([\s,]|#[^\n\r]+)+/g, " ").trim()));
  b.variables && a.push("variables=" + encodeURIComponent(u(b.variables)));
  b.extensions && a.push("extensions=" + encodeURIComponent(u(b.extensions)));
  return c + "?" + a.join("&");
}

function makeFetchOptions(a, b) {
  var c = "query" === a.kind && !!a.context.preferGetMethod;
  return B({}, a = "function" == typeof a.context.fetchOptions ? a.context.fetchOptions() : a.context.fetchOptions || {}, {
    body: !c && b ? JSON.stringify(b) : void 0,
    method: c ? "GET" : "POST",
    headers: c ? a.headers : B({}, {
      "content-type": "application/json"
    }, a.headers)
  });
}

function makeFetchSource(a, b, c) {
  return make((function(d) {
    var e = d.next, f = d.complete, g = "undefined" != typeof AbortController ? new AbortController : null, p = !1;
    Promise.resolve().then((function() {
      if (!p) {
        return g && (c.signal = g.signal), function C(a, b, c) {
          var e, d = !1;
          return (a.context.fetch || fetch)(b, c).then((function(a) {
            e = a;
            d = 200 > a.status || a.status >= ("manual" === c.redirect ? 400 : 300);
            return a.json();
          })).then((function(b) {
            if (!("data" in b) && !("errors" in b)) {
              throw Error("No Content");
            }
            return z(a, b, e);
          })).catch((function(b) {
            if ("AbortError" !== b.name) {
              return A(a, d ? Error(e.statusText) : b, e);
            }
          }));
        }(a, b, c);
      }
    })).then((function(a) {
      p || (p = !0, a && e(a), f());
    }));
    return function() {
      p = !0;
      g && g.abort();
    };
  }));
}

function createRequest(a, b) {
  a = y(a);
  return {
    key: b ? n(a.__key, u(b)) >>> 0 : a.__key,
    query: a,
    variables: b || {}
  };
}

var m, q, r, x;

import { make } from "wonka";

import { GraphQLError } from "graphql/error/GraphQLError.mjs";

import { Kind } from "graphql/language/kinds.mjs";

import { parse } from "graphql/language/parser.mjs";

import { print } from "graphql/language/printer.mjs";

m = function(a) {
  function b(b) {
    var f, c = b.networkError, e = b.response;
    f = function h(a, b) {
      var d = "";
      if (void 0 !== a) {
        return d = "[Network] " + a.message;
      }
      void 0 !== b && b.forEach((function c(a) {
        d += "[GraphQL] " + a.message + "\n";
      }));
      return d.trim();
    }(c, b = (b.graphQLErrors || []).map(k));
    a.call(this, f);
    this.name = "CombinedError";
    this.message = f;
    this.graphQLErrors = b;
    this.networkError = c;
    this.response = e;
  }
  a && (b.__proto__ = a);
  (b.prototype = Object.create(a && a.prototype)).constructor = b;
  b.prototype.toString = l;
  return b;
}(Error);

q = new Set, r = new WeakMap;

x = new Map;

export { m as C, B as _, A as a, makeFetchBody as b, makeFetchURL as c, makeFetchOptions as d, makeFetchSource as e, createRequest as f, u as g, w as h, y as k, z as m, v as s };
//# sourceMappingURL=2c01d8b2.mjs.map
